import { httpClient } from '../core/http';
import {
  agentService,
  crewService,
  knowledgeSourceService,
  organizationService,
} from './index';

export class DebugService {
  async debugAllServices(): Promise<{
    organizations: any;
    crews: any;
    knowledgeSources: any;
    agents: any;
  }> {
    // Iniciando debug de todos os serviços

    const results: {
      organizations: any;
      crews: any;
      knowledgeSources: any;
      agents: any;
    } = {
      organizations: null,
      crews: null,
      knowledgeSources: null,
      agents: null,
    };

    try {
      // Test 1: Organizations
      const orgsResponse = await organizationService.getAll();
      results.organizations = {
        success: true,
        data: orgsResponse,
        message: `Organizações carregadas: ${orgsResponse.items.length}`,
      };

      // Se temos organizações, testar os outros serviços
      if (orgsResponse.items.length > 0) {
        const firstOrg = orgsResponse.items[0];

        // Test 2: Crews
        try {
          const crewsResponse = await crewService.getByOrganization(
            firstOrg.id
          );
          results.crews = {
            success: true,
            data: crewsResponse,
            message: `Crews carregadas: ${crewsResponse.length}`,
          };
        } catch (error) {
          console.error('❌ Erro ao carregar crews:', error);
          results.crews = {
            success: false,
            error: error,
            message: `Erro ao carregar crews: ${
              error instanceof Error ? error.message : 'Erro desconhecido'
            }`,
          };
        }

        // Test 3: Knowledge Sources
        try {
          const ksResponse = await knowledgeSourceService.getByOrganization(
            firstOrg.id
          );
          results.knowledgeSources = {
            success: true,
            data: ksResponse,
            message: `Knowledge sources carregadas: ${ksResponse.length}`,
          };
        } catch (error) {
          console.error('❌ Erro ao carregar knowledge sources:', error);
          results.knowledgeSources = {
            success: false,
            error: error,
            message: `Erro ao carregar knowledge sources: ${
              error instanceof Error ? error.message : 'Erro desconhecido'
            }`,
          };
        }

        // Test 4: Agents
        try {
          const agentsResponse = await agentService.getByOrganization(
            firstOrg.id
          );
          results.agents = {
            success: true,
            data: agentsResponse,
            message: `Agents carregados: ${agentsResponse.length}`,
          };
        } catch (error) {
          console.error('❌ Erro ao carregar agents:', error);
          results.agents = {
            success: false,
            error: error,
            message: `Erro ao carregar agents: ${
              error instanceof Error ? error.message : 'Erro desconhecido'
            }`,
          };
        }
      } else {
        // Nenhuma organização encontrada, pulando outros testes
        results.crews = {
          success: false,
          message: 'Nenhuma organização disponível',
        };
        results.knowledgeSources = {
          success: false,
          message: 'Nenhuma organização disponível',
        };
        results.agents = {
          success: false,
          message: 'Nenhuma organização disponível',
        };
      }
    } catch (error) {
      console.error('❌ Erro geral no debug:', error);
      results.organizations = {
        success: false,
        error: error,
        message: `Erro ao carregar organizações: ${
          error instanceof Error ? error.message : 'Erro desconhecido'
        }`,
      };
    }

    return results;
  }

  async testDirectHTTP(): Promise<any> {
    try {
      // Test direct HTTP call
      const response = await httpClient.get('/v1/organizations');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('❌ HTTP direto falhou:', error);
      return { success: false, error: error };
    }
  }
}

export const debugService = new DebugService();
